import BaseService from '../base'

class home extends BaseService {
  // 首页数据
  async getHomeData () {
    return await this.get('/admin/home/home_data');
  }
  //主页小喇叭消息
  async getMessage (postData) {
    return await this.get('/admin/home/trumpet_message', postData);
  }
  //获取小程序二维码
  async qrCode () {
    return await this.get('/admin/home/home_data/qr_code');
  }
  //判断主办方是否关注公众号（用于推送订阅消息）
  async isSubscribe () {
    return await this.get('/admin/home/home_wx/is_subscribe');
  }
}

export default new home()
